<template>
  <nuttrema-layout-west-slide width="100%" minWidth="100%" theme="is-dark">
    <west-slide-left-navigation slot="navigation-top">
      <a @click="closePage" :title="$t('label.close')">
        <nuttrema-iconica-sidebar-link icon="far fa-times" theme="white"></nuttrema-iconica-sidebar-link>
      </a>
    </west-slide-left-navigation>
    <!-- end ~ navigation-top -->

    <div class="youtube__external-link" slot="navigation-bottom">
      <a @click="openInNewTab" :title="$t('label.open_in_new_window')">
        <i class="far fa-external-link"></i>
      </a>
    </div>

    <nuttrema-layout-east-block theme="is-transparent">
      <nuttrema-layout-west-three-vertical class="is-dark">
        <template v-if="title">
          <div slot="top-center" class="top--center__title">
            <span>{{ title }}</span>
          </div>
        </template>
        <template slot="center">
          <iframe width="100%" height="100%" :src="`https://www.youtube.com/embed/${file}?autoplay=1`" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </template>
      </nuttrema-layout-west-three-vertical>
    </nuttrema-layout-east-block>

  </nuttrema-layout-west-slide>
</template>

<script>
import Emitter from 'components/mixins/emitter';

import PageProps from 'components/mixins/page-props';
import NuttremaLayoutWestSlide from 'components/ui/layout/nuttrema-layout-west-slide';

import NuttremaLayoutEastBlock from 'components/ui/layout/nuttrema-layout-east-block';
import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';

import WestSlideLeftNavigation from 'components/ui/west-slide-component/west-slide-left-navigation';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

export default {
  name: 'page-help-overlay',
  mixins: [
    Emitter,
    PageProps,
  ],
  props: {
    file: {
      type: String,
      required: true,
      default: null,
    },
    anchor: {
      required: false,
      default: null,
    },
    title: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      help: null,
      toc: true,
      showTableOfContent: false,
      tocText: null,
    };
  },
  methods: {
    closePage() {
      this.$emit('close');
    },
    openInNewTab() {
      const url = `https://www.youtube.com/watch?v=${this.file}`;
      const win = window.open(url, '_blank');
      this.$emit('close');
      win.focus();
    },
  },
  components: {
    WestSlideLeftNavigation,
    NuttremaLayoutEastBlock,
    NuttremaLayoutWestSlide,
    NuttremaIconicaSidebarLink,
    NuttremaLayoutWestThreeVertical,
  },
  created() {},
};
</script>

<style lang="scss" scoped>
  .youtube__external-link {
    margin: 1em;
    a {
      color: #fff;
      i {
        font-size: 1.5em;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/shared/youtube/page-youtube-overlay.vue